export const ENROL_TYPE_FREE        = 'free';
export const ENROL_TYPE_MEDIUM      = 'mid';
export const ENROL_TYPE_HIGH        = 'high';
export const ENROL_TYPE_HUGE        = 'huge';

export const BANNER_MAIN            = 'main';
export const BANNER_USER_PANEL      = 'userPanel';



// WEBPACK FOOTER //
// ./src/Models/consts.js